import { Component, Directive, Input, Output, EventEmitter, HostBinding, HostListener, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
var SuiRating = (function () {
    function SuiRating() {
        this.ratingClasses = true;
        this._value = 0;
        this._max = 5;
        this.valueChange = new EventEmitter(false);
        this._hoveredIndex = -1;
        this.isReadonly = false;
    }
    Object.defineProperty(SuiRating.prototype, "max", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._max = parseInt(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SuiRating.prototype, "icons", {
        /**
         * @return {?}
         */
        get: function () {
            return Array(this._max);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} i
     * @return {?}
     */
    SuiRating.prototype.mouseover = function (i) {
        this._hoveredIndex = i;
    };
    /**
     * @return {?}
     */
    SuiRating.prototype.mouseout = function () {
        this._hoveredIndex = -1;
    };
    /**
     * @param {?} i
     * @return {?}
     */
    SuiRating.prototype.click = function (i) {
        if (!this.isReadonly) {
            this._value = i + 1;
            this.valueChange.emit(this._value);
        }
    };
    /**
     * @param {?} value
     * @return {?}
     */
    SuiRating.prototype.writeValue = function (value) {
        this._value = value;
    };
    return SuiRating;
}());
export { SuiRating };
SuiRating.decorators = [
    { type: Component, args: [{
                selector: 'sui-rating',
                exportAs: 'suiRating',
                template: "\n<i class=\"icon\"\n   *ngFor=\"let icon of icons; let i = index\"\n   (mouseover)=\"mouseover(i)\"\n   (click)=\"click(i)\"\n   [class.selected]=\"_hoveredIndex >= i && !isReadonly\"\n   [class.active]=\"_value > i\">\n</i>\n",
                styles: ["\n:host.read-only .icon {\ncursor: auto\n}\n"]
            },] },
];
/**
 * @nocollapse
 */
SuiRating.ctorParameters = function () { return []; };
SuiRating.propDecorators = {
    'ratingClasses': [{ type: HostBinding, args: ['class.ui',] }, { type: HostBinding, args: ['class.rating',] },],
    'max': [{ type: Input },],
    'valueChange': [{ type: Output },],
    'mouseout': [{ type: HostListener, args: ['mouseout',] },],
    'isReadonly': [{ type: HostBinding, args: ['class.read-only',] }, { type: Input },],
};
function SuiRating_tsickle_Closure_declarations() {
    /** @type {?} */
    SuiRating.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    SuiRating.ctorParameters;
    /** @type {?} */
    SuiRating.propDecorators;
    /** @type {?} */
    SuiRating.prototype.ratingClasses;
    /** @type {?} */
    SuiRating.prototype._value;
    /** @type {?} */
    SuiRating.prototype._max;
    /** @type {?} */
    SuiRating.prototype.valueChange;
    /** @type {?} */
    SuiRating.prototype._hoveredIndex;
    /** @type {?} */
    SuiRating.prototype.isReadonly;
}
export var /** @type {?} */ CUSTOM_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return SuiRatingValueAccessor; }),
    multi: true
};
var SuiRatingValueAccessor = (function () {
    /**
     * @param {?} host
     */
    function SuiRatingValueAccessor(host) {
        this.host = host;
        this.onChange = function () { };
        this.onTouched = function () { };
    }
    /**
     * @param {?} value
     * @return {?}
     */
    SuiRatingValueAccessor.prototype.writeValue = function (value) {
        this.host.writeValue(value);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    SuiRatingValueAccessor.prototype.registerOnChange = function (fn) { this.onChange = fn; };
    /**
     * @param {?} fn
     * @return {?}
     */
    SuiRatingValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    return SuiRatingValueAccessor;
}());
export { SuiRatingValueAccessor };
SuiRatingValueAccessor.decorators = [
    { type: Directive, args: [{
                selector: 'sui-rating',
                host: { '(valueChange)': 'onChange($event)' },
                providers: [CUSTOM_VALUE_ACCESSOR]
            },] },
];
/**
 * @nocollapse
 */
SuiRatingValueAccessor.ctorParameters = function () { return [
    { type: SuiRating, },
]; };
function SuiRatingValueAccessor_tsickle_Closure_declarations() {
    /** @type {?} */
    SuiRatingValueAccessor.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    SuiRatingValueAccessor.ctorParameters;
    /** @type {?} */
    SuiRatingValueAccessor.prototype.onChange;
    /** @type {?} */
    SuiRatingValueAccessor.prototype.onTouched;
    /** @type {?} */
    SuiRatingValueAccessor.prototype.host;
}
export var /** @type {?} */ SUI_RATING_DIRECTIVES = [SuiRating, SuiRatingValueAccessor];
//# sourceMappingURL=rating.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ng2-semantic-ui/components/rating/rating.js
// module id = ./node_modules/ng2-semantic-ui/components/rating/rating.js
// module chunks = vendor